import { render } from "./InventoryLogs.vue?vue&type=template&id=368b6002"
import script from "./InventoryLogs.vue?vue&type=script&setup=true&lang=js"
export * from "./InventoryLogs.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Inventory/InventoryLogs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "368b6002"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('368b6002', __exports__)) {
    api.reload('368b6002', __exports__)
  }
  
  module.hot.accept("./InventoryLogs.vue?vue&type=template&id=368b6002", () => {
    api.rerender('368b6002', render)
  })

}


export default __exports__